import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  CircularProgress,
  Typography,
  Chip,
  Card,
  CardContent,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import NetworkPreview from "./NetworkPreview";
import { networkDesignService } from "../../utils/services/networkDesignService";
import { toast } from "react-toastify";

const NetworkDesignViewer = ({ clientId, designId = null, data = null }) => {
  const [loading, setLoading] = useState(false);
  const [networkData, setNetworkData] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);

  useEffect(() => {
    if (data) {
      setNetworkData(data);
    } else if (designId) {
      fetchDesignById(designId);
    } else if (clientId) {
      fetchDesignByClient(clientId);
    }
  }, [clientId, designId, data]);

  const fetchDesignById = async (id) => {
    setLoading(true);
    try {
      const response = await networkDesignService.fetchById(id);
      setNetworkData(response);
    } catch (error) {
      console.error("Error fetching network design:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDesignByClient = async (client) => {
    setLoading(true);
    try {
      const response = await networkDesignService.fetchByClient(client);
      if (response.data && response.data.length > 0) {
        setNetworkData(response.data[0]); // Get the first/active design
      } else {
        toast.info("No network design found for this client");
      }
    } catch (error) {
      console.error("Error fetching network design:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!networkData) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <Typography color="textSecondary">
          No network design available
        </Typography>
      </Box>
    );
  }

  const { nodes = [], edges = [], name } = networkData;

  // Group nodes by row for display
  const nodesByRow = nodes.reduce((acc, node) => {
    if (!acc[node.row]) acc[node.row] = [];
    acc[node.row].push(node);
    return acc;
  }, {});

  // Sort nodes within each row by column
  Object.keys(nodesByRow).forEach((row) => {
    nodesByRow[row].sort((a, b) => a.column - b.column);
  });

  return (
    <Box>
      {/* Network Visualization */}
      {/* <Paper sx={{ mb: 3 }}> */}
      <NetworkPreview
        nodes={nodes}
        edges={edges}
        isEditable={false}
        onNodeMove={null}
      />
      {/* </Paper> */}

      {/* Node Legend/Information */}
      {/* <Paper sx={{ p: 3 }}>
        <CustomTypography variant="h6" sx={{ mb: 2 }}>
          Network Components
        </CustomTypography>

        {Object.keys(nodesByRow)
          .sort((a, b) => a - b)
          .map((row) => (
            <Box key={row} sx={{ mb: 3 }}>
              <Typography
                variant="subtitle2"
                color="textSecondary"
                sx={{ mb: 1 }}
              >
                Stage {parseInt(row) + 1}
              </Typography>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                {nodesByRow[row].map((node) => (
                  <Card
                    key={node.id}
                    sx={{
                      minWidth: 200,
                      cursor: "pointer",
                      transition: "all 0.3s",
                      "&:hover": {
                        boxShadow: 3,
                        transform: "translateY(-2px)",
                      },
                      border:
                        selectedNode?.id === node.id
                          ? "2px solid #4A90E2"
                          : "1px solid #e0e0e0",
                    }}
                    onClick={() => setSelectedNode(node)}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 1,
                        }}
                      >
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            bgcolor: node.color || "#4A90E2",
                            borderRadius: "4px",
                            mr: 1,
                          }}
                        />
                        <CustomTypography variant="subtitle1">
                          {node.label}
                        </CustomTypography>
                      </Box>
                      {node.type && (
                        <Chip label={node.type} size="small" sx={{ mt: 0.5 }} />
                      )}
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ display: "block", mt: 1 }}
                      >
                        Position: Column {node.column}, Row {node.row}
                      </Typography>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            </Box>
          ))}
      </Paper> */}

      {/* Connection Information */}
      {/* {edges.length > 0 && (
        <Paper sx={{ p: 3 }}>
          <CustomTypography variant="h6" sx={{ mb: 2 }}>
            Connections ({edges.length})
          </CustomTypography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {edges.map((edge) => {
              const fromNode = nodes.find((n) => n.id === edge.from);
              const toNode = nodes.find((n) => n.id === edge.to);
              return (
                <Box
                  key={edge.id}
                  sx={{
                    p: 1.5,
                    bgcolor: "#f5f5f5",
                    borderRadius: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Chip
                    label={fromNode?.label || edge.from}
                    size="small"
                    sx={{
                      bgcolor: fromNode?.color || "#4A90E2",
                      color: "#fff",
                    }}
                  />
                  <Typography variant="body2" color="textSecondary">
                    →
                  </Typography>
                  <Chip
                    label={toNode?.label || edge.to}
                    size="small"
                    sx={{
                      bgcolor: toNode?.color || "#4A90E2",
                      color: "#fff",
                    }}
                  />
                  {edge.label && (
                    <Typography variant="caption" color="textSecondary">
                      ({edge.label})
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        </Paper>
      )} */}
    </Box>
  );
};

export default NetworkDesignViewer;
